import { Link, useParams } from 'react-router-dom';
import { ProviderDetailPanel } from './ProviderDetailPanel';
import { ProviderModelHealthPanel } from './ProviderModelHealthPanel';
import { ProviderStatusChip } from './ProviderStatusChip';

/**
 * /dev-console/providers/:provider — the per-provider drill-down page
 * (replaces the old Balances modal: linkable, back/forward-friendly, and the
 * growth home for provider-specific panels — spend trend, error mix, setup
 * status all attach here).
 */
export function ProviderDetailPage() {
  const { provider } = useParams<{ provider: string }>();
  if (!provider) return null;
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <div className="mb-6">
        <Link to="/dev-console/providers" className="text-sm text-primary hover:underline">
          ← Providers
        </Link>
        <div className="flex items-center gap-3 mt-1">
          <h1 className="text-2xl font-bold">{provider}</h1>
          <ProviderStatusChip provider={provider} />
        </div>
      </div>
      <ProviderDetailPanel provider={provider} />
      <ProviderModelHealthPanel provider={provider} />
    </div>
  );
}
